import React from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { FormGroup } from 'reactstrap';

import { Intl } from 'components';

const SwitchInput = React.memo( ( {
  label, value, inputOnChange, inputName, onChange, formGroupClass, labelClass,
  intl, translateValues, isInvalid, meta, ...rest
} ) => (
  <FormGroup className={classnames( formGroupClass, { 'is-invalid': isInvalid } )}>
    {label
    && (
      <label className={classnames( 'form-control-label', labelClass )}>
        <Intl id={label} />
      </label>
    )}
    <label
      className="d-block custom-toggle"
    >
      <input
        {...rest}
        checked={value}
        type="checkbox"
        onChange={( val ) => {
          if ( inputOnChange ) inputOnChange( val );
          if ( onChange ) onChange( val );
        }}
      />
      <span
        className="custom-toggle-slider rounded-circle"
        data-label-off={intl.formatMessage( { id: 'no' } )}
        data-label-on={intl.formatMessage( { id: 'yes' } )}
      />
    </label>

    {isInvalid
    && (
      <div className="invalid-feedback">
        <Intl id={meta.error || meta.submitError} values={translateValues} />
      </div>
    )}
  </FormGroup>
) );

export default injectIntl( SwitchInput );
